import React, { useState } from 'react';
import { Cell, HtmlTable } from '../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { IconButton } from '../../../../../../../../CommonComponents/OPL/IconButton/IconButton';
import { EquityCompensationEditAssetForm } from '../EditAssetForm/components/EquityCompensationEditAssetForm/EquityCompensationEditAssetForm';
import { EquityCompensationAssetDTO } from '../../../../api/useEstatePlanningExplanationQuery';
import { BeneficiariesData } from '../../useBeneficiaries';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { EmptyState } from '../../../../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { formatDate } from '../../../../../../../../CommonUtils/formatDate';
import { BeneficiariesList } from '../BeneficiariesList/BeneficiariesList';
import { PDFSafeTableHeaderCaption } from '../../../../../../../../CommonComponents/OPL/HtmlTable/components/PDFSafeTableHeaderCaption/PDFSafeTableHeaderCaption';

interface BeneficiariesProps {
  isPrint?: boolean;
  data: BeneficiariesData<EquityCompensationAssetDTO>[];
}

export const EquityCompensation = ({ isPrint, data }: BeneficiariesProps) => {
  const [selectedAsset, setSelectedAsset] = useState<any | null>(null);

  if (data.length === 0) {
    return (
      <Box py="24">
        <EmptyState />
      </Box>
    );
  }

  return (
    <>
      {data.map(({ key, items }) => {
        return (
          <Box key={key} css="page-break-inside: avoid">
            <HtmlTable mb="24">
              <table>
                <colgroup>
                  <col width="25%" />
                  <col width="25%" />
                  <col width="25%" />
                  <col width="24%" />
                  <col width="1px" />
                </colgroup>

                <thead>
                  <PDFSafeTableHeaderCaption colSpan={5}>{items[0].Name}</PDFSafeTableHeaderCaption>

                  <tr>
                    <th>
                      <Text variant="smallCaps" textAlign="left">
                        Primary Beneficiary
                      </Text>
                    </th>
                    <th>
                      <Text variant="smallCaps" textAlign="left">
                        Contingent Beneficiary
                      </Text>
                    </th>
                    <th>
                      <Text variant="smallCaps" textAlign="left">
                        Method of Transfer
                      </Text>
                    </th>
                    <th>
                      <Text variant="smallCaps" textAlign="left">
                        Last Updated
                      </Text>
                    </th>
                    <th aria-label="Action Items" />
                  </tr>
                </thead>

                <tbody>
                  {items.map(equityCompensation => (
                    <tr key={equityCompensation.Name}>
                      <Cell>
                        <BeneficiariesList
                          beneficiaries={equityCompensation.PrimaryBeneficiaries}
                        />
                      </Cell>
                      <Cell>
                        <BeneficiariesList
                          beneficiaries={equityCompensation.ContingentBeneficiaries}
                        />
                      </Cell>
                      <Cell>
                        {typeof equityCompensation.TransferMethod === 'object'
                          ? equityCompensation.TransferMethod.label
                          : '-'}
                      </Cell>
                      <Cell>
                        {equityCompensation.LastUpdated
                          ? formatDate(equityCompensation.LastUpdated)
                          : '—'}
                      </Cell>
                      <Cell>
                        {!isPrint && (
                          <IconButton
                            variant="subtleInactive"
                            icon="far fa-pencil"
                            onClick={() => setSelectedAsset(equityCompensation)}
                            aria-label="Edit Item"
                          />
                        )}
                      </Cell>
                    </tr>
                  ))}
                </tbody>
              </table>
            </HtmlTable>
          </Box>
        );
      })}

      {selectedAsset !== null && (
        <EquityCompensationEditAssetForm
          asset={selectedAsset}
          onRequestClose={() => setSelectedAsset(null)}
        />
      )}
    </>
  );
};
